/* This module contains mapping for widget type hierarchy */

import columnChart from '../chart/column/column-chart-main.js';
import barChart from '../chart/bar/bar-chart-main.js';
import table from '../table/table-main.js';
import pieChart from '../chart/pie/pie-chart-main';
import bubbleChart from '../bubble/bubble-chart-main';
import waterfallChart from '../chart/waterfall/waterfall-chart-main';
import pnlChart from '../pnl/pnl-chart-main';
import mapStandard from '../map/world/map-standard-main';
import mapLeaflet from '../map/world/map-leaflet-main';
import label from '../label/label-main';
import sankeyFlow from '../sankey/sankey-main';
import list from '../list/list-main';
import webView from '../webview/web-view-main';
import twobytwo from '../twobytwo/twobytwo-main';
import iris from '../irishost/iris-main';
import richText from '../richtext/richtext-main';
import reportWidget from '../report-widget/report-widget-main';

// Widget type mapped to widget instances
var WIDGET_MODULE_MAP = {
	Chart: {
		Column: columnChart,
		Line: columnChart,
		Area: columnChart,
		Bar: barChart,
		Pie: pieChart,
		Doughnut: pieChart,
		Waterfall: waterfallChart
	},
	Table: table,
	BubbleChart: bubbleChart,
	PnL: pnlChart,
	Label: label,
	Map: {
		Standard: mapStandard,
		Satellite: mapLeaflet,
		Terrain: mapLeaflet,
		Hybrid: mapLeaflet,
		Unknown: mapStandard
	},
	Flow: {
		Sankey: sankeyFlow
	},
	List: list,
	WebView: webView,
	TwoByTwo: twobytwo,
	Iris: iris,
	RichText: richText,
	ReportWidget: reportWidget
};

// Widget type mapped to config key and widget subtype key
var WIDGET_CONFIG_MAP = {
	Chart: {
		ConfigKey: 'ChartConfig',
		SubTypeKey: 'ChartType'
	},
	Table: {
		ConfigKey: 'TableConfig',
		SubTypeKey: null
	},
	BubbleChart: {
		ConfigKey: 'BubbleChartConfig',
		SubTypeKey: null
	},
	PnL: {
		ConfigKey: 'PnLConfig',
		SubTypeKey: null
	},
	Map: {
		ConfigKey: 'MapConfig',
		SubTypeKey: 'MapViewType'
	},
	Label: {
		ConfigKey: 'LabelConfig',
		SubTypeKey: null
	},
	Flow: {
		ConfigKey: 'FlowConfig',
		SubTypeKey: 'FlowType'
	},
	List: {
		ConfigKey: 'ListConfig',
		SubTypeKey: null
	},
	WebView: {
		ConfigKey: 'WebViewConfig',
		SubTypeKey: null
	},
	TwoByTwo: {
		ConfigKey: 'TwoByTwoConfig',
		SubTypeKey: null
	},
	Iris: {
		ConfigKey: 'IrisConfig',
		SubTypeKey: null
	},
	RichText: {
		ConfigKey: 'RichTextConfig',
		SubTypeKey: null
	},
	ReportWidget: {
		ConfigKey: 'ReportWidgetConfig',
		SubTypeKey: null
	}
};

export { WIDGET_MODULE_MAP, WIDGET_CONFIG_MAP };